import React, { Fragment, useEffect, useState } from "react";
import {
  Select as AntSelect,
  Input,
  Form,
  Button,
  DatePicker,
  DatePickerProps,
  Select,
} from "antd";
import {
  TextField,
  Box,
  FormControl,
  Button as MUIButton,
  CircularProgress,
} from "@mui/material";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { CaretDownOutlined } from "@ant-design/icons";
import {
  Navigate,
  useLocation,
  useNavigate,
  useParams,
} from "react-router-dom";
import "./ProjectsAndOffsetCreation.scss";
import FileAttachments from "../common/FileAttachments";
import FileAttachmentsDetails from "../common/FileAttachmentsDetails";
import { toastMessage, parseDate } from "../../helper";
import {
  createOffsetProgramService,
  createOffsetService,
  getOffsetProgramsService,
  updateOffsetService,
} from "../../services/offsetService";
import { getEmissionCurrencyService } from "../../services/emissionService";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import CreatableSelect from "react-select/creatable";
import { RangePickerProps } from "antd/es/date-picker";
dayjs.extend(customParseFormat);

const ProjectsAndOffsetCreation = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const { RangePicker } = DatePicker;
  const dayFormat = "DD/MM/YYYY";
  let isEdit = !!id;
  const { state } = useLocation();
  const [currencies, setCurrencies] = useState<any>();
  const [bunitCurrencySymbol, setBunitCurrencySymbol] = useState("");
  const [offsetAttachmentData, setOffsetLogAttachmentData] = useState({
    id: "",
    attachments: [],
  } as any);
  const [defaultMonitoringRange, setDefaultMonitoringRange] = useState<any>([
    null,
    null,
  ]);
  const [defaultPurchaseDate, setDefaultPurchaseDate] = useState<any>(null);
  const projectTypes = [
    "Renewable Energy Development",
    "Waste Management",
    "Forestry and Conservation",
    "Community Projects",
    "Blue Carbon Projects",
    "Agriculture and Land Management",
    "Capture & Destruction of high potency GHGs",
    "Energy efficiency",
  ];
  const certificateTypes = [
    "Voluntary Carbon credits (in t CO2e)",
    "iREC (in MWh)",
  ];

  const [programOptions, setProgramOptions] = useState([] as any[]);
  const [isLoading, setIsLoading] = useState(false);

  // const statusOptions = [
  //   "Hold",
  //   "Retired-Partial",
  //   "Retired-Fully",
  //   "Transferred",
  // ];

  const [offsetData, setOffsetData] = useState<any>({
    projectName: "",
    projectType: "",
    projectId: "",
    certificateNumber: "",
    certificateType: certificateTypes[0],
    registryAccountId: "",
    registryOwnerName: "",
    carbonPrice: "",
    currency: "",
    value: "",
    program: "",
    projectDeveloper: "",
    projectFinancer: "",
    independentVerifier: "",
    purchaseDate: null,
    vintage: null,
    monitoringStartDate: null,
    monitoringEndDate: null,
    creditStatus: "Hold",
    attachments: [],
  });

  const checkMinus = (e: any) => {
    if (
      e.code === "ArrowDown" ||
      e?.code === "ArrowUp" ||
      e?.code === "Minus"
    ) {
      e.preventDefault();
    }
  };

  const getProgramsList = () => {
    getOffsetProgramsService()
      .then((res) => {
        const resData = res.data.map((each: any) => {
          return {
            value: each.name,
            label: each.name,
          };
        });
        setProgramOptions(resData);
      })
      .catch((e: any) => {
        console.log(e);
      });
  };

  const createProgramList = (newProgram: any) => {
    let company =
      localStorage.getItem("company") &&
      JSON.parse(localStorage.getItem("company") || "").id;
    const reqData = {
      company,
      name: newProgram,
    };
    createOffsetProgramService(reqData)
      .then((res: any) => {
        console.log(res);
      })
      .catch((e: any) => {
        console.log(e);
      });
  };

  const handleProgramChangeSelect = (newValue: any, actionMeta: any) => {
    setOffsetData({
      ...offsetData,
      program: newValue,
    });
  };

  const clearProgramInput = () => {
    setOffsetData({
      ...offsetData,
      program: null,
    });
  };

  const handleProgramCreateOption = (inputValue: any) => {
    const newOption = {
      label: inputValue,
      value: inputValue.trim(),
    };
    createProgramList(inputValue);
    setProgramOptions([...programOptions, newOption]);
    setOffsetData({
      ...offsetData,
      program: newOption,
    });
  };

  useEffect(() => {
    getProgramsList();
    if (!isEdit) {
      getEmissionCurrencyService().then((res: any) => {
        let allCurrencies = res.data;
        setCurrencies(allCurrencies);

        let bunitCurrencyId = JSON.parse(
          localStorage.getItem("preference") || ""
        )?.currency;
        setOffsetData({ ...offsetData, currency: bunitCurrencyId });

        const bunitCurrencySymbol = allCurrencies.find(
          (c: any) => c.id === bunitCurrencyId
        )?.symbol;
        setBunitCurrencySymbol(bunitCurrencySymbol);
      });
    }
  }, []);

  useEffect(() => {
    if (isEdit) {
      let offsetDetailedItem = state.offsetDetailedItem;
      let attachmentData = JSON.parse(offsetDetailedItem.attachments);
      let attachments = attachmentData.files;
      if (attachmentData) {
        setOffsetLogAttachmentData({
          attachments: attachments,
          id: offsetData.id,
        });
      }

      getEmissionCurrencyService().then((res: any) => {
        let allCurrencies = res.data;
        setCurrencies(allCurrencies);

        let currencyId = offsetDetailedItem?.currency;

        const bunitCurrencySymbol = allCurrencies.find(
          (c: any) => c.id === currencyId
        )?.symbol;
        setBunitCurrencySymbol(bunitCurrencySymbol);
      });
      setOffsetData({
        ...offsetData,
        projectName: offsetDetailedItem.project_name,
        projectType: offsetDetailedItem.project_type,
        projectId: offsetDetailedItem.project_id,
        certificateNumber: offsetDetailedItem.certificate_number,
        certificateType: offsetDetailedItem.certificate_type,
        registryAccountId: offsetDetailedItem.registry_account_id,
        registryOwnerName: offsetDetailedItem.registry_owner_name,
        carbonPrice: offsetDetailedItem.carbon_price,
        value: offsetDetailedItem.value,
        program: {
          value: offsetDetailedItem.program,
          label: offsetDetailedItem.program,
        },
        projectDeveloper: offsetDetailedItem.project_developer,
        projectFinancer: offsetDetailedItem.project_financer,
        independentVerifier: offsetDetailedItem.independent_verifier,
        creditStatus: offsetDetailedItem.credit_status,
        currency: offsetDetailedItem.currency,
        purchaseDate: new Date(offsetDetailedItem.purchase_date),
        vintage: offsetDetailedItem.vintage,
        monitoringStartDate: new Date(offsetDetailedItem.monitoring_start_date),
        monitoringEndDate: new Date(offsetDetailedItem.monitoring_end_date),
        id: state.offsetId,
        attachments: attachments,
      });
      if (
        offsetDetailedItem.monitoring_start_date &&
        offsetDetailedItem.monitoring_end_date
      ) {
        const startDate = new Date(offsetDetailedItem.monitoring_start_date);
        const endDate = new Date(offsetDetailedItem.monitoring_end_date);
        setDefaultMonitoringRange([
          dayjs(new Date(offsetDetailedItem.monitoring_start_date)),
          dayjs(new Date(offsetDetailedItem.monitoring_end_date)),
        ]);
      }
      if (offsetDetailedItem.purchase_date) {
        setDefaultPurchaseDate(
          dayjs(new Date(offsetDetailedItem.purchase_date))
        );
      }
    }
  }, []);

  const handleChange = (value: any, key: any) => {
    const updateObject: any = {
      [key]: value,
    };
    setOffsetData({ ...offsetData, ...updateObject });
  };

  const onPurchaseDateChange: DatePickerProps["onChange"] = (
    date: any,
    dateString: any
  ) => {
    let fullDate = new Date(date.$d);
    setOffsetData({ ...offsetData, ["purchaseDate"]: fullDate });
  };

  const onVintageChange: DatePickerProps["onChange"] = (
    date: any,
    dateString: any
  ) => {
    setOffsetData({ ...offsetData, ["vintage"]: date.year().toString() });
  };

  const setMonitoringPeriod = (val: any) => {
    const updateObject: any = {};
    updateObject.monitoringStartDate = val[0] ? new Date(val[0].$d) : null;
    updateObject.monitoringEndDate = val[1] ? new Date(val[1].$d) : null;
    setOffsetData({ ...offsetData, ...updateObject });
  };

  const handleSubmit = () => {
    setIsLoading(true);
    var payload = {
      ...offsetData,
      uomName: offsetData.certificateType === "iREC (in MWh)" ? "MWh" : "tCO2e",
    };
    payload.attachments = { files: offsetData.attachments };
    payload.program = offsetData.program.value;
    if (!isEdit) {
      createOffsetService(payload)
        .then((res: any) => {
          toastMessage("Offset Created Successfully", "success");
          navigate("/offsets");
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          setIsLoading(false);
        });
    } else {
      updateOffsetService(payload)
        .then((res: any) => {
          toastMessage("Offset Updated Successfully", "success");
          navigate("/offsets");
        })
        .catch((err: any) => {
          console.log(err);
        })
        .finally(() => {
          setIsLoading(false);
        });
    }
  };

  const handleCancel = () => {
    navigate("/offsets");
  };

  const isValidForm = () => {
    return (
      offsetData?.projectName &&
      offsetData?.projectType &&
      offsetData?.projectId &&
      offsetData?.certificateNumber &&
      offsetData?.certificateType &&
      offsetData?.registryAccountId &&
      offsetData?.registryOwnerName &&
      offsetData?.carbonPrice &&
      offsetData?.currency &&
      offsetData?.value &&
      offsetData?.value > 0 &&
      offsetData?.program &&
      offsetData?.projectDeveloper &&
      offsetData?.purchaseDate &&
      offsetData?.vintage &&
      offsetData?.monitoringStartDate &&
      offsetData?.monitoringEndDate &&
      offsetData?.creditStatus
    );
  };

  return (
    <div className="flex flex-col h-full">
      <div className="flex flex-col px-8 py-4 overflow-y-auto pw-offset-height">
        <div className="flex pw-input-label pw-create-label">
          {false ? "Edit" : "Create"} offset
        </div>
        <Form layout="vertical">
          <Box display="flex" justifyContent="flex-start" gap={8}>
            <Form.Item
              label={
                <span>
                  Carbon project name{" "}
                  <span className="pw-mandatory-icon">*</span>
                </span>
              }
              className="pw-offset-form-field"
            >
              <Input
                placeholder="Enter project name"
                value={offsetData.projectName}
                onChange={(e) => handleChange(e.target.value, "projectName")}
                className="h-[2.5rem]"
              />
            </Form.Item>

            <Form.Item
              label={
                <span>
                  Project Id <span className="pw-mandatory-icon">*</span>
                </span>
              }
              className="pw-offset-form-field"
            >
              <Input
                placeholder="Enter project id"
                value={offsetData.projectId}
                onChange={(e) => handleChange(e.target.value, "projectId")}
                className="h-[2.5rem]"
              />
            </Form.Item>
          </Box>

          <Form.Item
            label={
              <span>
                Carbon offset project type{" "}
                <span className="pw-mandatory-icon">*</span>
              </span>
            }
            className="pw-offset-form-field"
          >
            <AntSelect
              suffixIcon={<CaretDownOutlined />}
              placeholder="Select project type"
              onChange={(value) => handleChange(value, "projectType")}
              className="pw-offset-dropdown"
              value={offsetData.projectType || undefined}
            >
              {projectTypes.map((type) => (
                <AntSelect.Option key={type} value={type}>
                  {type}
                </AntSelect.Option>
              ))}
            </AntSelect>
          </Form.Item>

          <Box display="flex" justifyContent="flex-start" gap={8}>
            <Form.Item
              label={
                <span>
                  Registry account id{" "}
                  <span className="pw-mandatory-icon">*</span>
                </span>
              }
              className="pw-offset-form-field"
            >
              <Input
                placeholder="Enter registry account id"
                value={offsetData.registryAccountId}
                onChange={(e) =>
                  handleChange(e.target.value, "registryAccountId")
                }
                className="h-[2.5rem]"
              />
            </Form.Item>

            <Form.Item
              label={
                <span>
                  Registry owner name{" "}
                  <span className="pw-mandatory-icon">*</span>
                </span>
              }
              className="pw-offset-form-field"
            >
              <Input
                placeholder="Enter registry owner name"
                value={offsetData.registryOwnerName}
                onChange={(e) =>
                  handleChange(e.target.value, "registryOwnerName")
                }
                className="h-[2.5rem]"
              />
            </Form.Item>
          </Box>

          <Box display="flex" justifyContent="flex-start" gap={8}>
            <Form.Item
              label={
                <span>
                  Certificate number{" "}
                  <span className="pw-mandatory-icon">*</span>
                </span>
              }
              className="pw-offset-form-field"
            >
              <Input
                placeholder="Enter certificate number"
                value={offsetData.certificateNumber}
                onChange={(e) =>
                  handleChange(e.target.value, "certificateNumber")
                }
                className="h-[2.5rem]"
              />
            </Form.Item>

            <Form.Item
              label={
                <span>
                  Carbon offset credit price{" "}
                  <span className="pw-mandatory-icon">*</span>
                </span>
              }
              className="pw-offset-form-field"
            >
              <Input
                addonBefore={
                  <AntSelect
                    value={offsetData?.currency || undefined}
                    placeholder="Select currency"
                    suffixIcon={<CaretDownOutlined />}
                    className="pw-currency-width"
                    onChange={(value) => handleChange(value, "currency")}
                  >
                    {currencies?.map((currency: any) => (
                      <AntSelect.Option key={currency?.id} value={currency?.id}>
                        {currency?.symbol}
                      </AntSelect.Option>
                    ))}
                  </AntSelect>
                }
                type="number"
                onKeyDown={checkMinus}
                placeholder="Enter credit price"
                value={offsetData.carbonPrice}
                onChange={(e) => handleChange(e.target.value, "carbonPrice")}
                className="pw-currency-price"
              />
            </Form.Item>
          </Box>

          <Box display="flex" justifyContent="flex-start" gap={8}>
            <Form.Item
              label={
                <span>
                  Carbon certificate type{" "}
                  <span className="pw-mandatory-icon">*</span>
                </span>
              }
              className="pw-offset-form-field"
            >
              <AntSelect
                suffixIcon={<CaretDownOutlined />}
                placeholder="Select certificate type"
                onChange={(value) => handleChange(value, "certificateType")}
                className="pw-offset-dropdown"
                value={offsetData.certificateType || undefined}
                defaultValue={certificateTypes[0]}
              >
                {certificateTypes.map((type) => (
                  <AntSelect.Option key={type} value={type}>
                    {type}
                  </AntSelect.Option>
                ))}
              </AntSelect>
            </Form.Item>

            <Form.Item
              label={
                <span>
                  Carbon offset amount (
                  {offsetData.certificateType === "iREC (in MWh)"
                    ? "MWh"
                    : "tCO2e"}
                  ) <span className="pw-mandatory-icon">*</span>
                </span>
              }
              className="pw-offset-form-field"
            >
              <Input
                type="number"
                onKeyDown={checkMinus}
                placeholder="Enter amount"
                value={offsetData.value}
                onChange={(e) => handleChange(e.target.value, "value")}
                className="h-[2.5rem]"
              />
            </Form.Item>
          </Box>

          <Form.Item
            label={
              <span>
                Carbon offset program{" "}
                <span className="pw-mandatory-icon">*</span>
              </span>
            }
            className="pw-offset-form-field"
          >
            {/* <AntSelect
              suffixIcon={<CaretDownOutlined />}
              placeholder="Select program"
              onChange={(value) => handleChange(value, "program")}
              className="pw-offset-dropdown"
              value={offsetData.program || undefined}
            >
              {programs.map((program) => (
                <AntSelect.Option key={program} value={program}>
                  {program}
                </AntSelect.Option>
              ))}
            </AntSelect> */}
            <CreatableSelect
              value={offsetData.program}
              onChange={handleProgramChangeSelect}
              onCreateOption={handleProgramCreateOption}
              onMenuOpen={clearProgramInput}
              options={programOptions}
              placeholder="Search Program or create Program"
            />
          </Form.Item>

          <Form.Item
            label={
              <span>
                Carbon offset project developers{" "}
                <span className="pw-mandatory-icon">*</span>
              </span>
            }
            className="pw-offset-form-field"
          >
            <Input
              placeholder="Enter developer name"
              value={offsetData.projectDeveloper}
              onChange={(e) => handleChange(e.target.value, "projectDeveloper")}
              className="h-[2.5rem]"
            />
          </Form.Item>

          <Form.Item
            label="Carbon offset project financed by investors"
            className="pw-offset-form-field"
          >
            <Input
              placeholder="Enter project financed by investors"
              value={offsetData.projectFinancer}
              onChange={(e) => handleChange(e.target.value, "projectFinancer")}
              className="h-[2.5rem]"
            />
          </Form.Item>

          <Form.Item
            label="Carbon offset project independent verifier"
            className="pw-offset-form-field"
          >
            <Input
              placeholder="Enter project independent verifier"
              value={offsetData.independentVerifier}
              onChange={(e) =>
                handleChange(e.target.value, "independentVerifier")
              }
              className="h-[2.5rem]"
            />
          </Form.Item>

          <Box display="flex" justifyContent="flex-start" gap={8}>
            <Form.Item
              label={
                <span>
                  Vintage <span className="pw-mandatory-icon">*</span>
                </span>
              }
              className="pw-offset-form-field"
            >
              <DatePicker
                className="pw-offset-date"
                picker="year"
                value={
                  offsetData.vintage
                    ? dayjs(offsetData.vintage.toString(), "YYYY")
                    : null
                }
                placeholder="Select vintage year"
                onChange={onVintageChange}
                suffixIcon={<ArrowDropDownIcon />}
              />
            </Form.Item>

            {!isEdit || defaultMonitoringRange[0] ? (
              <Form.Item
                label={
                  <span>
                    Monitoring period{" "}
                    <span className="pw-mandatory-icon">*</span>
                  </span>
                }
                className="pw-offset-form-field"
              >
                <RangePicker
                  className="pw-offset-date"
                  onCalendarChange={(val: any) => {
                    setMonitoringPeriod(val);
                  }}
                  placeholder={["From", "To"]}
                  format={dayFormat}
                  getPopupContainer={(triggerNode: any) => {
                    return triggerNode.parentNode;
                  }}
                  defaultValue={defaultMonitoringRange}
                />
              </Form.Item>
            ) : (
              ""
            )}
          </Box>

          {!isEdit || defaultPurchaseDate ? (
            <Form.Item
              label={
                <span>
                  Carbon offset credit purchased date{" "}
                  <span className="pw-mandatory-icon">*</span>
                </span>
              }
              className="pw-offset-form-field"
            >
              <DatePicker
                className="pw-offset-date"
                placeholder="Select purchase date"
                format={dayFormat}
                onChange={onPurchaseDateChange}
                defaultValue={defaultPurchaseDate}
              />
            </Form.Item>
          ) : (
            ""
          )}

          {/* <Form.Item
            label={
              <span>
                Carbon offset credit status{" "}
                <span className="pw-mandatory-icon">*</span>
              </span>
            }
            className="pw-offset-form-field"
          >
            <AntSelect
              suffixIcon={<CaretDownOutlined />}
              placeholder="Select credit status"
              onChange={(value) => handleChange(value, "creditStatus")}
              className="pw-offset-dropdown"
              value={offsetData.creditStatus || undefined}
            >
              {statusOptions.map((creditStatus) => (
                <AntSelect.Option key={creditStatus} value={creditStatus}>
                  {creditStatus}
                </AntSelect.Option>
              ))}
            </AntSelect>
          </Form.Item> */}
        </Form>

        <div>
          <FileAttachmentsDetails
            formData={offsetData}
            setFormData={setOffsetData}
          ></FileAttachmentsDetails>
        </div>
      </div>

      <div className="flex flex-row justify-end pw-bunit-footer w-full gap-6">
        <div
          className="pw-bunit-button-light pw-bunit-button-next text-neutral bg-white font-bold"
          onClick={handleCancel}
        >
          Cancel
        </div>
        <button
          className={`pw-bunit-button-primary pw-bunit-button-next text-white  font-bold ${
            isValidForm()
              ? isLoading
                ? "text-black bg-neutral-300"
                : "cursor-pointer bg-primary"
              : "text-black bg-neutral-300"
          }`}
          onClick={() => {
            isValidForm() && !isLoading && handleSubmit();
          }}
          disabled={!isValidForm() || isLoading}
        >
          {isLoading ? (
            <div className="flex flex-row gap-2 p-2">
              <span>{"Saving up"}</span>
              <CircularProgress size={20} />
            </div>
          ) : (
            <span>{"Save"}</span>
          )}
        </button>
      </div>
    </div>
  );
};

export default ProjectsAndOffsetCreation;
